import React, { useState, useEffect } from 'react';
import { ShoppingBag, X, Trash2, Plus, Minus, Menu } from 'lucide-react';
import { useCart } from '../context/CartContext';

const NavbarTop = ({ onMenuClick }) => {
    const [scrolled, setScrolled] = useState(false);
    const [isCartOpen, setIsCartOpen] = useState(false);
    const { cart, removeFromCart, updateQuantity, validateOrder } = useCart();

    const totalItems = cart.reduce((acc, item) => acc + item.quantity, 0);
    const totalPrice = cart.reduce((acc, item) => acc + (item.price * item.quantity), 0);

    useEffect(() => {
        const handleScroll = () => setScrolled(window.scrollY > 50);
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <>
            <nav className={`navbar-top ${scrolled ? 'scrolled' : ''}`} style={{
                position: 'fixed',
                top: 0,
                right: 0,
                width: '100%',
                height: '80px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                padding: '0 5%',
                zIndex: 900,
                background: scrolled ? 'rgba(10, 10, 12, 0.9)' : 'transparent',
                backdropFilter: scrolled ? 'blur(10px)' : 'none',
                transition: 'all 0.4s'
            }}>
                {/* Mobile Menu Toggle (Left on Mobile) */}
                <div
                    className="mobile-toggle"
                    onClick={onMenuClick}
                    style={{ cursor: 'pointer', display: 'none' }}
                >
                    <Menu size={32} color="white" />
                </div>

                <div style={{ flex: 1 }}></div>

                <div style={{ display: 'flex', gap: '2rem', alignItems: 'center' }}>
                    {/* BASKET BUTTON */}
                    <div
                        style={{ position: 'relative', cursor: 'pointer' }}
                        onClick={() => setIsCartOpen(true)}
                    >
                        <ShoppingBag size={28} color="white" />
                        {totalItems > 0 && (
                            <span style={{
                                position: 'absolute',
                                top: '-5px',
                                right: '-5px',
                                background: 'var(--primary)',
                                color: 'black',
                                fontSize: '11px',
                                fontWeight: '900',
                                width: '20px',
                                height: '20px',
                                borderRadius: '50%',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                boxShadow: '0 0 10px rgba(245, 158, 11, 0.5)'
                            }}>{totalItems}</span>
                        )}
                    </div>
                </div>
            </nav>

            {/* Cart Drawer / Modal */}
            <div className={`cart-modal ${isCartOpen ? 'open' : ''}`} style={{
                position: 'fixed',
                top: 0,
                right: isCartOpen ? '0' : '-800px',
                width: '100%',
                maxWidth: '480px',
                height: '100vh',
                background: 'rgba(10, 10, 12, 0.98)',
                backdropFilter: 'blur(30px)',
                borderLeft: '1px solid var(--glass-border)',
                zIndex: 2000,
                padding: '3rem 2.5rem',
                display: 'flex',
                flexDirection: 'column',
                transition: 'right 0.6s cubic-bezier(0.16, 1, 0.3, 1)'
            }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '3rem' }}>
                    <h2 style={{ fontSize: '2.5rem', fontWeight: '800' }}>Your <span className="text-accent">Basket</span></h2>
                    <X size={35} onClick={() => setIsCartOpen(false)} style={{ cursor: 'pointer', color: 'var(--text-muted)' }} />
                </div>

                <div className="cart-items" style={{ flexGrow: 1, overflowY: 'auto', paddingRight: '10px' }}>
                    {cart.length === 0 ? (
                        <div style={{ textAlign: 'center', padding: '4rem 0' }}>
                            <ShoppingBag size={80} style={{ color: 'var(--glass-border)', marginBottom: '1.5rem' }} />
                            <p style={{ color: 'var(--text-muted)', fontSize: '1.1rem' }}>Your basket is empty.</p>
                        </div>
                    ) : (
                        cart.map((item) => (
                            <div key={item.id} className="cart-item" style={{
                                display: 'flex', gap: '1.5rem', padding: '1.5rem', borderRadius: '24px', marginBottom: '1.5rem',
                                border: '1px solid var(--glass-border)',
                                background: 'rgba(255, 255, 255, 0.03)'
                            }}>
                                <img src={item.image} alt={item.name} style={{ width: '100px', height: '100px', borderRadius: '18px', objectFit: 'cover' }} />
                                <div style={{ flexGrow: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                                    <h4 style={{ fontSize: '1.25rem', marginBottom: '6px', fontWeight: '700' }}>{item.name}</h4>
                                    <p style={{ color: 'var(--primary)', fontWeight: '800', fontSize: '1.2rem' }}>${(item.price * item.quantity).toFixed(2)}</p>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '1.5rem', marginTop: '15px' }}>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', background: 'rgba(255,255,255,0.08)', borderRadius: '12px', padding: '8px 12px' }}>
                                            <Minus size={16} style={{ cursor: 'pointer', color: 'var(--primary)' }} onClick={() => updateQuantity(item.id, -1)} />
                                            <span style={{ fontSize: '1rem', width: '24px', textAlign: 'center', fontWeight: '800' }}>{item.quantity}</span>
                                            <Plus size={16} style={{ cursor: 'pointer', color: 'var(--primary)' }} onClick={() => updateQuantity(item.id, 1)} />
                                        </div>
                                        <Trash2 size={20} style={{ color: '#ef4444', cursor: 'pointer' }} onClick={() => removeFromCart(item.id)} />
                                    </div>
                                </div>
                            </div>
                        ))
                    )}
                </div>

                {cart.length > 0 && (
                    <div className="cart-footer" style={{ borderTop: '1px solid var(--glass-border)', paddingTop: '3rem', marginTop: '1.5rem' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '2.5rem', fontSize: '1.75rem', fontWeight: '900' }}>
                            <span>Total</span>
                            <span className="text-accent">${totalPrice.toFixed(2)}</span>
                        </div>
                        <button className="submit-btn" style={{ width: '100%', fontSize: '1.25rem', padding: '1.5rem', borderRadius: '20px' }} onClick={() => {
                            validateOrder();
                            setIsCartOpen(false);
                        }}>
                            Validate Order
                        </button>
                    </div>
                )}
            </div>

            {/* Overlay for Cart */}
            {isCartOpen && (
                <div onClick={() => setIsCartOpen(false)} style={{
                    position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.8)', backdropFilter: 'blur(12px)', zIndex: 1500
                }}></div>
            )}
        </>
    );
};

export default NavbarTop;
